
import { defineComponent } from 'vue';
import { useMainStore } from '@/store/mainStore';
import DriveUiWrapper from './DriveUIWrapper.vue';
import MoveNavigation from '@/components/BottomPopUp/PopUpTypes/MoveTo/MoveNavigation.vue';

export default defineComponent({
  props: {
    title: { type: String, reqiured: true },
    currentPosition: { type: String, default: '' },
    showDots: { type: Boolean, default: false },
  },
  components: {
    DriveUiWrapper,
    MoveNavigation,
  },
  emits: ['openMoveToPopUp'],
  setup(props, { emit }) {
    const mainStore = useMainStore();

    function openMoveTo() {
      emit('openMoveToPopUp');
    }

    return {
      openMoveTo,
      mainStore,
    };
  },
});
